import axios from 'axios';
import { axiosRequestInterceptor, axiosResponseInterceptor } from './Interceptors';

const env = process.env.REACT_APP_ENV;

const DEVELOPMENT_URL = process.env.REACT_APP_Backend_DEVELOPMENT_URL;

const TESTING_URL = process.env.REACT_APP_Backend_TESTING_URL;

const PRODUCTION_URL = process.env.REACT_APP_Backend_PRODUCTION_URL;

const urlSwitch = env => {
  switch (env) {
    case 'development':
      return DEVELOPMENT_URL;
    case 'test':
      return TESTING_URL;
    case 'production':
      return PRODUCTION_URL;
    default:
      return DEVELOPMENT_URL;
  }
};
// base axios instance
const baseInstance = axios.create({
  baseURL: urlSwitch(env),
  timeout: 10000
});

// add interceptors to instance
const attachInterceptors = axiosInstance => {
  axiosInstance.interceptors.request.use(
    axiosRequestInterceptor.onFulfilled,
    axiosRequestInterceptor.onRejected
  );

  axiosInstance.interceptors.response.use(
    axiosResponseInterceptor.onFulfilled,
    axiosResponseInterceptor.onRejected
  );
};

attachInterceptors(baseInstance);

export default baseInstance;
